import {atom} from "recoil";
import {FormSearchOWAncillaryExceptionModel, OWAncillaryExceptionSelectFE} from "../api/types/owAncillaryException";

export const owAncillaryExceptionSelectAtom = atom<OWAncillaryExceptionSelectFE[]>({
    key: "owAncillaryExceptionSelectAtom",
    default: []
});

export const initialOWAncillaryExceptionFilters: FormSearchOWAncillaryExceptionModel = {
    commercialCategoryId: null,
    commercialSegmentId: null,
    name: "",
    productCode: "",
    ancillaryId: null,
    reservationFrom: null,
    reservationTo: null,
    pickupDateFrom: null,
    pickupDateTo: null,
    dealers: [],
    legalEntities: []
};
export const owAncillaryExceptionFiltersAtom = atom<FormSearchOWAncillaryExceptionModel>({
    key: "owAncillaryExceptionFiltersAtom",
    default: initialOWAncillaryExceptionFilters
});